import { FC } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { MessageMedium } from 'modules/graphql/types';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';

import { LocaleSwitcher } from 'modules/templateEditor/common/LocaleSwitcher';
import { ALIGNMENT } from 'ui/selects';
import { spacing } from 'ui/theme';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';

import { SendTestMessage, OverflowButton, PreviewOnDevicesButton } from '.';

const Container = styled.div`
  border-bottom: ${({ theme }) => `${theme.spacing.values.single} solid #bdbdbd`};
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.spacing.utils.pxToRem(15)};
`;

const Left = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  gap: ${spacing.half};
  justify-content: flex-start;
`;

const Right = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  gap: ${spacing.half};
  justify-content: flex-start;
`;

export const PreviewControlBar: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { locales } = useLocaleSettingsContext();
  const { medium } = useTemplateQueryContext();

  return (
    <Container>
      <Left>
        {!isEmpty(locales) && <LocaleSwitcher horizontalAlignment={ALIGNMENT.LEFT} />}
        {medium === MessageMedium.Email && <PreviewOnDevicesButton />}
        {children}
      </Left>
      <Right>
        <SendTestMessage />
        <OverflowButton />
      </Right>
    </Container>
  );
};
